import EdH1 from './ed-h1/ed-h1.vue';
import EdH2 from './ed-h2/ed-h2.vue';
import EdH3 from './ed-h3/ed-h3.vue';
import EdP from './ed-p/ed-p.vue';
import EdIcon from './ed-icon/ed-icon.vue';
import EdLink from './ed-link/ed-link.vue';
import EdAddMenu from './ed-add-menu/ed-add-menu.vue';
import EdLoading from './ed-loading/ed-loading.vue';
import EdModal from './ed-modal/ed-modal.vue';
import EdAddMenuOptions from './ed-add-menu-options/ed-add-menu-options.vue';
import EdText from './ed-text/ed-text.vue';
import EdSpinner from './ed-spinner/ed-spinner.vue';
import EdMeetingsComponent from './ed-meetings/ed-meetings.vue';
import EdMeetingComponent from './ed-meeting/ed-meeting.vue';
import EdMeetingMemberComponent from './ed-meeting-member/ed-meeting-member.vue';
import EdMeetingModalComponent from './ed-meeting-modal/ed-meeting-modal.vue';
import EdTabsHeader from './ed-tabs-header/ed-tabs-header.vue';
import EdBreadCrumbs from './ed-breadcrumbs/ed-breadcrumbs.vue';
import EdEmpty from './ed-empty/ed-empty.vue';
import EdCopyrights from './ed-copyrights/ed-copyrights.vue';
import EdBadge from './ed-badge/ed-badge.vue';
import EdLoadingBars from './ed-loading-bars/ed-loading-bars.vue';
import EdError from './ed-error/ed-error.vue';
import EdPaginationFooterComponent from './ed-pagination-footer/ed-pagination-footer.component.vue';
import EdInlineMsgBox from './ed-inline-msg-box/ed-inline-msg-box.vue';
import EdTaskWhiteboard from './ed-task-whiteboard/ed-task-whiteboard.vue';
import EdTaskBoardGroup from './ed-task-board-group/ed-task-board-group.component.vue';
import EdWhiteboardUsers from './ed-whiteboard-users/ed-whiteboard-users.vue';
import EdBoardTaskUsers from './ed-board-task-users/ed-board-task-users.vue';
import EdVerifyCodeInputComponent from './ed-verify-code-input/ed-verify-code-input.component.vue';
import EdBoard from './ed-board/ed-board.component';
import EdBoardV2 from './ed-board/ed-board-v2.component';
import EdBlankWhiteboard from './ed-blank-whiteboard/ed-blank-whiteboard.vue';
import EdBlankWhiteboardUsers from './ed-blank-whiteboard-users/ed-blank-whiteboard-users.vue';
import EdButtonToggle from '@/components/common/ed-button-toggle/ed-button-toggle.vue';
import EdButtonIcon from '@/components/common/ed-button-icon/ed-button-icon.vue';
import EdDivider from './ed-divider/ed-divider.vue';
import EdSkeletonLoader from '@/components/common/ed-skeleton-loader/ed-skeleton-loader.vue';
import EdProgressLinear from '@/components/common/ed-progress-linear/ed-progress-linear.vue';
import EdTabsHeaderMenu from '@/components/common/ed-tabs-header-menu/ed-tabs-header-menu.vue';
import EdTabsContent from '@/components/common/ed-tabs-content/ed-tabs-content.vue';
import EdList from '@/components/common/ed-list/ed-list.vue';
import EdListItem from '@/components/common/ed-list-item/ed-list-item.vue';
import EdListItemCheckbox from '@/components/common/ed-list-item-checkbox/ed-list-item-checkbox.vue';
import EdChip from './ed-chip/ed-chip.vue';
import EdChipGroup from './ed-chip-group/ed-chip-group.vue';
import EdSimpleChip from './ed-simple-chip/ed-simple-chip.vue';
import EdSwitch from './ed-switch/ed-switch.vue';
import EdTooltip from './ed-tooltip/ed-tooltip.vue';
import EdEditDialog from './ed-edit-dialog/ed-edit-dialog.component.vue';
import EdMenu from './ed-menu/ed-menu.vue';
import EdSlider from './ed-slider/ed-slider.vue';
import EdNavigationDrawer from './ed-navigation-drawer/ed-navigation-drawer.vue';

export default {
  components: {
    EdH1,
    EdH2,
    EdH3,
    EdP,
    EdIcon,
    EdLink,
    EdAddMenu,
    EdLoading,
    EdModal,
    EdAddMenuOptions,
    EdText,
    EdSpinner,
    EdMeetingsComponent,
    EdMeetingComponent,
    EdMeetingMemberComponent,
    EdMeetingModalComponent,
    EdTabsHeader,
    EdBreadCrumbs,
    EdEmpty,
    EdCopyrights,
    EdBadge,
    EdLoadingBars,
    EdError,
    EdPaginationFooterComponent,
    EdInlineMsgBox,
    EdTaskBoardGroup,
    EdWhiteboardUsers,
    EdBoardTaskUsers,
    EdBoard,
    EdBoardV2,
    EdBlankWhiteboard,
    EdBlankWhiteboardUsers,
    EdVerifyCodeInput: EdVerifyCodeInputComponent,
    EdButtonToggle,
    EdButtonIcon,
    EdDivider,
    EdSkeletonLoader,
    EdProgressLinear,
    EdTabsHeaderMenu,
    EdTabsContent,
    EdList,
    EdListItem,
    EdListItemCheckbox,
    EdChip,
    EdChipGroup,
    EdSimpleChip,
    EdSwitch,
    EdTooltip,
    EdEditDialog,
    EdMenu,
    EdSlider,
    EdNavigationDrawer
  }
};
